module.exports = __webpack_public_path__ + "img/login_slogan_en@2x.5b2c6399.png";